

export default {
  kategoriList: [],
  totalBannerHome: 0,
  totalBannerPPOB: 0,
  totalBannerDonasi: 0
}
